import { createMediaButton } from "../create-media-button.js";
import { FullscreenButtonCore, FullscreenButtonDataAttrs } from "@videojs/core";
import { selectFullscreen } from "@videojs/core/dom";
//#region src/ui/fullscreen-button/component.tsx
/** A button that toggles fullscreen. */
const FullscreenButton = createMediaButton({
	displayName: "FullscreenButton",
	core: FullscreenButtonCore,
	stateAttrMap: FullscreenButtonDataAttrs,
	selector: selectFullscreen,
	action: (core, state) => core.toggle(state),
	hotkeyAction: "toggleFullscreen",
	isSupported: (state) => !state.hidden,
	focusContainerOnPointerActivation: true
});
//#endregion
export { FullscreenButton };

//# sourceMappingURL=component.js.map